import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import ModalForm from "../../../../components/compounds/modalForm/ModalForm.compunds"
import {
  isNotEmpty,
  validateFieldValue,
  checkValidationsAndIfHaveErrors,
} from "../../../../utils/validations.utils"
import FormContainer from "../../../../components/layouts/containers/FormContainer.container"
import FieldContainer from "../../../../components/layouts/containers/FieldContainer.container"
import InputTextForm from "../../../../components/molecules/InputTextForm.molecule"
import SecondaryButton from "../../../../components/molecules/buttons/SecondaryButton.molecule"
import PrimaryButton from "../../../../components/molecules/buttons/PrimaryButton.molecule"
import {
  getLastApprovedVacationRangeByVacationId,
  requestApprovedVacationCancelation,
} from "../../../../services/vacation.service"
import {
  MY_VACATION_STATES,
  VACATIONS_CANCEL_APPROVED_REQUEST_SUCCESS,
  VACATIONS_SAVE_ERROR_MESSAGE,
} from "../../../../consts/modules/vacations.consts"
import useToast from "../../../../hooks/useToast.hook"
const ModalCancelMyVacationApproved = ({
  visible,
  setVisible,
  selectedVacationRequest,
  triggerRefresh,
}) => {
  const initialDataState = {
    cancelationMotive: "",
  }
  const initialFieldsState = {
    cancelationMotive: {
      value: "",
      errors: [],
      typeValidations: [isNotEmpty],
      validationsOptions: {},
    },
  }
  const [submitting, setSubmitting] = useState(false)
  const [data, setData] = useState(initialDataState)
  const [validations, setValidations] = useState(initialFieldsState)
  const [lastApprovedVacationRequest, setLastApprovedVacationRequest] =
    useState()
  const { setSuccessMessage, setErrorMessage } = useToast()
  useEffect(() => {
    if (visible && selectedVacationRequest) {
      fetchLastApprovedVacationRequest()
    }
  }, [visible, selectedVacationRequest])
  const fetchLastApprovedVacationRequest = async () => {
    try {
      const response = await getLastApprovedVacationRangeByVacationId(
        selectedVacationRequest.idVacations
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      setLastApprovedVacationRequest(response.result[0])
    } catch (error) {
      setErrorMessage({
        title: "Error",
        message: error.message,
      })
    }
  }
  const handleChange = ({ target: { name, value } }) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }))
    setValidations(validateFieldValue(validations, name, value))
  }
  const handleSubmit = async () => {
    setSubmitting(true)
    try {
      const response = await requestApprovedVacationCancelation(
        selectedVacationRequest.idVacations,
        lastApprovedVacationRequest.vacationRangeId,
        data.cancelationMotive
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      setVisible("")
      resetFormState()
      triggerRefresh()
      setSuccessMessage(VACATIONS_CANCEL_APPROVED_REQUEST_SUCCESS)
    } catch (error) {
      setErrorMessage(VACATIONS_SAVE_ERROR_MESSAGE)
    } finally {
      setSubmitting(false)
    }
  }
  const resetFormState = () => {
    setData(initialDataState)
    setValidations(initialFieldsState)
  }
  const modalFooterTemplate = () => {
    return (
      <div>
        <SecondaryButton
          rounded
          label="Volver"
          onClick={() => {
            setVisible(MY_VACATION_STATES.QUERY)
            resetFormState()
          }}
          disabled={submitting}
        />
        <PrimaryButton
          rounded
          icon={`pi ${submitting ? "pi-spin pi-spinner" : "pi-check"}`}
          label="Aceptar"
          onClick={handleSubmit}
          disabled={submitting || checkValidationsAndIfHaveErrors(validations)}
        />
      </div>
    )
  }
  return (
    <ModalForm
      visible={visible}
      setVisible={setVisible}
      headerTitle="Solicitar cancelación"
      headerIcon={
        <i className="pi pi-exclamation-triangle text-4xl clr-danger" />
      }
      footer={modalFooterTemplate()}
      cleanUp={resetFormState}
    >
      <div className="flex flex-column gap-3">
        <span>
          El administrador verá tu solicitud de cancelación, por favor agrega el
          motivo para explicarle la razón:
        </span>
        <FormContainer>
          <FieldContainer className="flex flex-column w-full m-0">
            <InputTextForm
              name="cancelationMotive"
              value={data.cancelationMotive}
              label="Motivo de la cancelación"
              onChange={(e) => {
                handleChange(e)
              }}
              onBlur={() => {
                handleChange({
                  target: {
                    name: "cancelationMotive",
                    value: data.cancelationMotive?.trim(),
                  },
                })
              }}
              validations={validations.cancelationMotive}
              error={validations.cancelationMotive.errors}
              autoFocus
            />
          </FieldContainer>
        </FormContainer>
      </div>
    </ModalForm>
  )
}

export default ModalCancelMyVacationApproved

ModalCancelMyVacationApproved.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  selectedVacationRequest: PropTypes.object,
  triggerRefresh: PropTypes.func,
}
